import { FunctionComponent } from "react";
import { Outlet } from "react-router";

import "./FeaturePage.scss";

const FeaturePage: FunctionComponent = () => {
  return <Outlet />;
};

export { FeaturePage };
